import React from 'react';
import EntitlementSectionTitle from '../../../shared/EntitlementSectionTitle';
import EntitlementsList from './EntitlementsList';
import { SectionsWrapper, SectionBlock } from './index.styles';
import type { FeatureSection, PlanId, Feature } from '../../../types';

interface EntitlementsSectionProps {
  featureSections: FeatureSection[];
  featureKey: PlanId;
  planName: string;
  onSelectFeature: (feature: Feature) => void;
}

const EntitlementsSection: React.FC<EntitlementsSectionProps> = ({
  featureSections,
  featureKey,
  planName,
  onSelectFeature,
}) => (
  <SectionsWrapper>
    {featureSections.map(section => (
      <SectionBlock key={section.id}>
        <EntitlementSectionTitle section={section} />
        <EntitlementsList
          features={section.features}
          featureKey={featureKey}
          planName={planName}
          onSelectFeature={onSelectFeature}
        />
      </SectionBlock>
    ))}
  </SectionsWrapper>
);

export default EntitlementsSection;
